import React, { useState, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Button, CircularProgress } from '@mui/material';
import styles from './InfoTemplateView.module.css';

const Nps = lazy(() => import('../components/nps/Nps'));

export default function InfoTemplateView({ children, showNps }) {
  const { t } = useTranslation();
  const [feedbackSent, setFeedbackSent] = useState(false);

  const isOpenedFromParent =
    window.top !== window.self || Boolean(window.opener);

  function onClose() {
    window.top.postMessage('ended', '*');
    window.close();
  }

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Paper className={styles.paper}>
          {!feedbackSent ? (
            <>
              {children}
              {showNps && (
                <Suspense fallback={<CircularProgress size={30} />}>
                  <Nps
                    onFeedbackSent={() => setFeedbackSent(true)}
                    onClose={onClose}
                    isOpenedFromParent={isOpenedFromParent}
                  />
                </Suspense>
              )}
            </>
          ) : (
            <div>
              <h2>{t('Thank you for your feedback!')}</h2>
              <p>
                {t(
                  'We appreciate your input and will work on improving your experience'
                )}
              </p>
              {isOpenedFromParent && (
                <Button
                  sx={{ marginTop: '0.5rem' }}
                  color="newgreen"
                  variant="contained"
                  onClick={onClose}
                >
                  {t('Close')}
                </Button>
              )}
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}
